import React, { FormEvent, useState } from 'react'
import { Icon, IconButton, Popover, TextField, containsInvisibleInput, makeStyles } from '@cicero/ui'
import { PageDoc, PageSchema } from '../../models'

export const PageEditorToolbar = ({ page, children }: { page: PageDoc, children: JSX.Element }) => {
  const [title, setTitle] = useState(page.title)
  const { headerContainer, titleContainer, titleInput } = styles()

  const onTitleBlur = async (e: FormEvent<any>) => {
    e.preventDefault()
    if (title !== page.title) {
      // if (page._isTemporary) { await page.save() }
      page.atomicSet('title', title)
    }
  }

  return <header className={headerContainer}>
    <div className={titleContainer}>
      <PageIconSelector page={page} />
      <form className={titleInput} onSubmit={onTitleBlur}>
        <TextField
          variant="outlined"
          value={title}
          onChange={(ev) => setTitle(ev.target.value)}
          onBlur={onTitleBlur}
          autoFocus={!page.title}
        />
      </form>
      { children }
    </div>
    {/* <nav className={navContainer}>
      Title Links
    </nav> */}
  </header>
}

const styles = makeStyles({
  headerContainer: {
    background: '#FFF',
    borderBottom: '3px solid #DDD',
    display: 'flex',
    flexDirection: 'column',
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',

    '& .icon': {
      padding: '16px',
    },

    '& ul': {
      display: 'flex',
      flexDirection: 'row',
      listStyleType: 'none',
      margin: 0,

      '& li': {
        padding: 12,
      },
    },
  },
  titleInput: {
    flexGrow: 1,
    display: 'flex',

    '& div': {
      margin: '0',
      textAlign: 'left',
      fontSize: 32,
      border: 'none',
      flexGrow: 1,
      '& input': {
        background: '#FFF',
        fontSize: '30px',
        padding: '12px 6px',
      },
      ...containsInvisibleInput,
    },
  },
  navContainer: {
    padding: '12px 6px',
    borderTop: '1px solid #DDD',
  },
})

export const PageIconSelector = ({ page }: { page: PageDoc }) => {
  const { wrapper, popoverWrapper } = iconStyles()
  const [icon, setIcon] = useState(page.icon || PageSchema.DEFAULT_ICON)
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => { setAnchorEl(event.currentTarget) }
  const handleClose = () => { setAnchorEl(null) }
  const handleIconSelection = (i: string) => {
    setIcon(i)
    page.atomicSet('icon', i)
  }

  return <span className={wrapper}>
    <IconButton aria-describedby={id} onClick={handleClick}>
      <Icon fontSize="large">{icon}</Icon>
    </IconButton>
    <Popover
      id={id}
      className={popoverWrapper}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      transformOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      { PageSchema.ICON_OPTIONS.map((i) => <IconButton key={i} onClick={() => handleIconSelection(i)}>
        <Icon>{i}</Icon>
      </IconButton>) }
    </Popover>
  </span>
}

const iconStyles = makeStyles({
  wrapper: {
    margin: '0 0 0 6px',
  },
  popoverWrapper: {
    maxWidth: 272,
  },
})
